/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Loop_Mode_1_DescInputs */

const en_mk_loop_mode_1_desc = /** @type {(inputs: Mk_Loop_Mode_1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The agent moves to the next task as long as evidence passes. For Utility tasks and small projects.`)
};

const id_mk_loop_mode_1_desc = /** @type {(inputs: Mk_Loop_Mode_1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent lanjut ke task berikutnya selama bukti lulus. Untuk task Utility dan proyek kecil.`)
};

/**
* | output |
* | --- |
* | "The agent moves to the next task as long as evidence passes. For Utility tasks and small projects." |
*
* @param {Mk_Loop_Mode_1_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_loop_mode_1_desc = /** @type {((inputs?: Mk_Loop_Mode_1_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Loop_Mode_1_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_loop_mode_1_desc(inputs)
	return en_mk_loop_mode_1_desc(inputs)
});